// amicusIndustryData.js

export const industryDummyData = [
  // LOGISTICS CONSULTING ADVISORY
  {
    slug: "logistics-consulting-advisory",
    bgImage: "/images/industries/hero.webp",
    title: "Logistics Consulting & Advisory", // [file:4]
    subTitle:
      "Partnering with logistics businesses to enhance profitability, operational efficiency, and service reliability in a rapidly evolving global supply chain.", // [file:4]
    industryOverview: {
      icon: "/images/industries/overview.svg",
      description:
        "The logistics sector operates under margin pressure driven by fuel volatility, fragmented vendor ecosystems, working-capital intensity, and rising service expectations. Sustainable performance depends on cost-to-serve discipline, network optimisation, technology adoption, and strong financial and governance frameworks.",
      keySegments: {
        titleImage: "/images/industries/key-segment-1.webp",
        accentTitle: "Key Segments of the Logistics Industry",
        title: "Specialised advisory support across the logistics value chain",
        subTitle:
          "We provide targeted consulting and advisory services across key logistics sub-segments, addressing the distinct operating models, cost structures, and governance challenges within each area of the logistics ecosystem",
        services: [
          {
            title: "Transportation & Freight Services",
            titleImage: "/images/industries/key-segment-1.webp",
            subTitle: "Businesses focused on physical movement of goods.",
            points: [
              "Road transport (FTL, LTL, PTL)",
              "Rail freight and rail-linked multimodal transport",
              "Coastal shipping",
              "Inland waterways transport",
              "RO-RO and vehicle logistics",
            ],
          },
          {
            title: "Freight Forwarding & International Trade",
            titleImage: "/images/industries/key-segment-2.webp",
            subTitle: "Asset-light coordination of cross-border cargo.",
            points: [
              "Ocean freight forwarding (FCL, LCL, breakbulk)",
              "Air freight forwarding",
              "Customs clearance and compliance",
              "Trade documentation and regulatory handling",
              "Overseas agent and trade lane management",
            ],
          },
          {
            title: "Warehousing & Storage",
            titleImage: "/images/industries/key-segment-3.webp",
            subTitle: "Infrastructure-led storage and handling services.",
            points: [
              "General warehousing and distribution centers",
              "Bonded warehousing and FTWZs",
              "Cold storage and temperature-controlled facilities",
              "In-plant and captive warehouses",
              "Value-added services (packing, labeling, kitting)",
            ],
          },
          {
            title: "Contract Logistics / 3PL",
            titleImage: "/images/industries/key-segment-4.webp",
            subTitle: "Integrated outsourcing of logistics functions.",
            points: [
              "End-to-end warehousing and transportation contracts",
              "Dedicated fleet and manpower models",
              "Industry-specific contract logistics (retail, FMCG, pharma)",
              "SLA-driven logistics execution",
            ],
          },
          {
            title: "Supply Chain Management / 4PL–5PL",
            titleImage: "/images/industries/key-segment-5.webp",
            subTitle: "Control and orchestration rather than execution.",
            points: [
              "Network design and optimisation",
              "Control tower and visibility platforms",
              "Vendor and carrier management",
              "Planning, analytics, and coordination across 3PLs",
            ],
          },
          {
            title: "Last-Mile & Distribution Logistics",
            titleImage: "/images/industries/key-segment-6.webp",
            subTitle: "Customer-facing delivery operations.",
            points: [
              "B2B distribution",
              "B2C and e-commerce fulfilment",
              "Hyperlocal and same-day delivery",
              "Reverse logistics and returns management",
            ],
          },
          {
            title: "Cold Chain & Temperature-Controlled Logistics",
            titleImage: "/images/industries/key-segment-7.webp",
            subTitle: "Specialised handling of sensitive cargo.",
            points: [
              "Pharma and healthcare logistics",
              "Food, dairy, and frozen logistics",
              "Agri produce cold chains",
              "Vaccine and life-science logistics",
            ],
          },
          {
            title: "Project, ODC & Heavy Logistics",
            titleImage: "/images/industries/key-segment-8.webp",
            subTitle: "Low-volume, high-complexity movements.",
            points: [
              "Over-dimensional cargo (ODC)",
              "Project cargo for infrastructure, energy, and industrial sectors",
              "Heavy lift and charter logistics",
            ],
          },
          {
            title: "Bulk & Commodity Logistics",
            titleImage: "/images/industries/key-segment-9.webp",
            subTitle: "High-volume, low-margin commodity movement.",
            points: [
              "Agri bulk logistics",
              "Coal, minerals, and metals logistics",
              "Liquid bulk and tank logistics",
            ],
          },
          {
            title: "Automotive & Finished Vehicle Logistics",
            titleImage: "/images/industries/key-segment-10.webp",
            subTitle: "Segment-specific logistics for auto OEMs.",
            points: [
              "Inbound auto supply chain",
              "Vehicle transportation (domestic and export)",
              "Spare parts logistics",
            ],
          },
          {
            title: "Digital & Platform-Based Logistics",
            titleImage: "/images/industries/key-segment-11.webp",
            subTitle: "Technology-led logistics businesses.",
            points: [
              "Freight marketplaces and aggregators",
              "Digital freight forwarding",
              "TMS, WMS, and control-tower platforms",
              "Visibility, tracking, and analytics solutions",
            ],
          },
        ],
      },
    },

    howWeHelp: [
      {
        icon: "/images/industries/help-1.svg",
        description:
          "Enhancing supply chain visibility and operational efficiency.", // [file:4]
      },
      {
        icon: "/images/industries/help-2.svg",
        description:
          "Reducing logistics costs through financial restructuring and optimisation.", // [file:4]
      },
      {
        icon: "/images/industries/help-3.svg",
        description:
          "Strengthening workflow reliability across warehousing and last-mile delivery.", // [file:4]
      },
      {
        icon: "/images/industries/help-4.svg",
        description:
          "Supporting digital transformation and adoption of modern logistics technologies.", // [file:4]
      },
    ],
    keySolutions: {
      background: "/images/industries/key-solutions.webp",
      description:
        "We offer a comprehensive suite of services to empower your business to stay ahead in this dynamic industry.", // [file:4]
      cardData: [
        {
          icon: "/images/industries/key-solutions-1.svg",
          title: "Supply Chain Restructuring and Cost Optimisation",
          description:
            "Redesign supply chain structures to reduce cost-to-serve, improve asset utilisation, and enhance operating margins.", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-2.svg",
          title: "Profit Enhancement and Margin Improvement",
          description:
            "Identify revenue leakages, optimise pricing and yield, improve cost structures, and drive sustainable profitability improvements.", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-3.svg",
          title: "Route Optimisation and Network Design",
          description:
            "Analyse routes, hubs, and fleet deployment to improve utilisation, reduce transit costs, and enhance service levels.", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-4.svg",
          title: "Technology, IT, and AI Enablement",
          description:
            "Support digital transformation through IT system upgrades, analytics, and AI-led optimisation across operations, planning, and decision-making.", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-5.svg",
          title: "Credit Control and Working Capital Management",
          description:
            "Strengthen receivables management, credit policies, and collection processes to improve cash flow and reduce DSO. ", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-6.svg",
          title: "Vendor Management Systems (VMS) and Governance",
          description:
            "Design and implement vendor management frameworks covering performance monitoring, cost control, compliance, and multi-vendor governance.", // [file:4]
        },
        {
          icon: "/images/industries/key-solutions-7.svg",
          title: "Governance Frameworks for Multi-Vendor Logistics Networks",
          description:
            "Establish controls, SLAs, KPIs, and review mechanisms to manage complex vendor ecosystems effectively.", // [file:4]
        },
      ],
    },
    industryInsights:
      "Updates on supply chain trends, operational efficiency, and global logistics developments ",
    testimonialSubTitle:
      "Client experiences that highlight our impact on supply chain efficiency",
    conversationSubTitle:
      "Whether you're optimizing supply chain efficiency, improving delivery performance, or evaluating expansion opportunities, our logistics advisors are here to guide you with a structured, impact-driven approach. Speak with our experts to identify the right strategic moves for your business. ",
  },

  // MANUFACTURING CONSULTING ADVISORY
  {
    slug: "manufacturing-consulting-advisory",
    bgImage: "/images/industries/manufacturing-advisory/hero.webp",
    title: "Manufacturing Consulting & Advisory", // [file:4]
    subTitle:
      "Providing manufacturers with strategies to strengthen their competitive edge, improve operational efficiency, and thrive in a globally connected landscape.", // [file:4]
    industryOverview: {
      icon: "/images/industries/manufacturing-advisory/overview.svg",
      description:
        "The manufacturing industry is a cornerstone of economic development, facing unique challenges related to maintaining operational efficiency, driving innovation, and achieving sustainability goals. Manufacturers must constantly adapt to technological advancements, manage complex global supply chains, and secure capital for capacity expansion and modernization.", // [file:4]
    },
    howWeHelp: [
      {
        icon: "/images/industries/manufacturing-advisory/help-1.svg",
        description:
          "Optimizing plant operations and production efficiency through strategic planning.", // [file:4]
      },
      {
        icon: "/images/industries/manufacturing-advisory/help-2.svg",
        description:
          "Guiding businesses on Industry 4.0 adoption and technology integration.", // [file:4]
      },
      {
        icon: "/images/industries/manufacturing-advisory/help-3.svg",
        description:
          "Supporting capacity expansion with strong financial and capital strategies.", // [file:4]
      },
      {
        icon: "/images/industries/manufacturing-advisory/help-4.svg",
        description:
          "Delivering data-driven insights for M&A decisions and operational restructuring.", // [file:4]
      },
    ],
    keySolutions: {
      description:
        "We support manufacturing companies across profitability improvement, growth strategy, capital readiness, and institutional strengthening: ", // [file:4]
      background:
        "/images/industries/manufacturing-advisory/key-solutions.webp",
      cardData: [
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-1.svg",
          description:
            "Holistic business diagnostics to identify profitability gaps, cost inefficiencies, and value leakage across products, customers, and operations, with a clear focus on improving EBITDA and return metrics. ", // [file:4]
        },
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-2.svg",
          description:
            "Detailed analysis of cost structures, pricing discipline, and margin drivers to strengthen contribution margins and improve commercial decision-making across the manufacturing value chain. ", // [file:4]
        },
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-3.svg",
          description:
            "Growth and go-to-market advisory including market prioritisation, customer segmentation, channel strategy, and pricing governance to support sustainable and profitable expansion. ", // [file:4]
        },
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-4.svg",
          description:
            "Capital-raise and investor-readiness support covering financial due diligence, valuation, investor positioning, and governance preparedness for strategic investments or IPOs. ", // [file:4]
        },
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-5.svg",
          description:
            "Working capital and cash-flow optimisation covering inventory management, receivables discipline, payables strategy, and cash conversion cycle improvement to release trapped liquidity. ", // [file:4]
        },
        {
          icon: "/images/industries/manufacturing-advisory/key-solutions-6.svg",
          description:
            "Design of robust MIS, budgeting, and performance management frameworks, including KPI definition and monthly review mechanisms to strengthen management control and visibility. ", // [file:4]
        },
      ],
    },
    industryInsights:
      "Insights on Industry 4.0 adoption, plant optimisation, and manufacturing market shifts",
    testimonialSubTitle:
      "Feedback showcasing our support in operational excellence and growth planning ",
    conversationSubTitle:
      "Modern manufacturing demands smarter processes, sharper financial planning, and readiness for scale. Our advisors work with you to refine operations, enhance productivity, and prepare for long-term competitiveness. Start a conversation with our team to explore the next steps.",
  },

  // RETAIL CONSULTING ADVISORY
  {
    slug: "retail-consulting-advisory",
    bgImage: "/images/industries/retail-consulting/hero.webp",
    title: "Retail Consulting & Advisory", // [file:4]
    subTitle:
      "Helping retailers drive growth through innovative strategies, digital transformation, and effective omni-channel experiences in a sector driven by evolving customer preferences.", // [file:4]
    industryOverview: {
      icon: "/images/industries/retail-consulting/overview.svg",
      description:
        "The vibrant retail sector is defined by rapidly changing customer preferences, technological shifts, and the pressure to deliver seamless omni-channel experiences. Key challenges include inventory management, data-driven personalization, competition from e-commerce, and the need for resilient, agile operations. Resilience and profitability depend on continuous innovation and digital agility.", // [file:4]
    },
    howWeHelp: [
      {
        icon: "/images/industries/retail-consulting/help-1.svg",
        description:
          "Improving omni-channel performance and customer experience strategies.", // [file:4]
      },
      {
        icon: "/images/industries/retail-consulting/help-2.svg",
        description:
          "Strengthening demand forecasting, inventory accuracy, and cash-flow resilience.", // [file:4]
      },
      {
        icon: "/images/industries/retail-consulting/help-3.svg",
        description:
          "Enhancing profitability through margin and cost-structure optimisation.", // [file:4]
      },
      {
        icon: "/images/industries/retail-consulting/help-4.svg",
        description:
          "Supporting digital transformation for evolving retail and consumer trends.", // [file:4]
      },
    ],
    keySolutions: {
      description:
        "We offer expertise to guide your retail business into the future.", // [file:4]
      background: "/images/industries/retail-consulting/key-solutions.png",
      cardData: [
        {
          icon: "/images/industries/retail-consulting/key-solutions-1.svg",
          description:
            "Retail profitability diagnostics and store-level financial optimisation.", // [file:4]
        },
        {
          icon: "/images/industries/retail-consulting/key-solutions-2.svg",
          description:
            "Financial planning for omni-channel expansion and digital adoption.", // [file:4]
        },
        {
          icon: "/images/industries/retail-consulting/key-solutions-3.svg",
          description:
            "Working-capital restructuring for seasonal and demand-driven cycles.", // [file:4]
        },
        {
          icon: "/images/industries/retail-consulting/key-solutions-4.svg",
          description:
            "Strategic advisory for franchise rollout, urban expansion, or repositioning.", // [file:4]
        },
      ],
    },
    industryInsights:
      "Trends in consumer behaviour, omni-channel strategy, and retail market performance ",
    testimonialSubTitle:
      "Insights from retailers who transformed performance and customer experience with us ",
    conversationSubTitle:
      "Customer expectations are evolving faster than ever. We help retailers realign operations, improve margins, and build stronger omni-channel journeys. Speak with our specialists to find the right strategic direction for your brand. ",
  },

  // E-COMMERCE CONSULTING ADVISORY
  {
    slug: "ecommerce-consulting-advisory",
    bgImage: "/images/industries/e-commerce/hero.webp",
    title: "E-commerce Consulting & Advisory", // [file:4]
    subTitle:
      "Strategic guidance for e-commerce enterprises to optimize digital operations, scale rapidly, and ensure financial resilience in the hyper-competitive online marketplace.", // [file:4]
    industryOverview: {
      icon: "/images/industries/e-commerce/overview.svg",
      description:
        "The e-commerce landscape is characterized by explosive growth, intense competition, and constant technological disruption. Businesses face complex challenges including managing global supply chain volatility, optimizing conversion funnels, navigating cross-border taxation, and securing capital for rapid scaling and fulfillment infrastructure. Success requires digital agility and robust financial planning.", // [file:4]
    },
    howWeHelp: [
      {
        icon: "/images/industries/e-commerce/help-1.svg",
        description:
          "Boosting conversion, retention, and overall funnel performance.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-2.svg",
        description:
          "Strengthening financial planning and readiness for rapid scale-up.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-3.svg",
        description:
          "Improving multi-channel operational workflows and fulfillment efficiency.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-4.svg",
        description:
          "Supporting valuation, funding preparation, and acquisition strategy.", // [file:4]
      },
    ],
    keySolutions: {
      background: "/images/industries/e-commerce/key-solutions.webp",
      description:
        "We offer expertise to scale and optimize your e-commerce platform.", // [file:4]
      cardData: [
        {
          icon: "/images/industries/e-commerce/key-solutions-1.svg",
          description:
            "Unit economics optimisation for high-growth digital brands.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-2.svg",
          description:
            "Financial strategy for rapid scaling and multi-market expansion.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-3.svg",
          description:
            "Capital advisory for fulfillment centres, last-mile partnerships, and tech upgrades.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-4.svg",
          description:
            "Strategic valuation, investor readiness, and acquisition modelling.", // [file:4]
        },
      ],
    },
    industryInsights:
      "Analysis of digital commerce growth, platform scaling, and online market dynamics ",
    testimonialSubTitle:
      "Real stories from digital brands that scaled smarter and faster with our guidance ",
    conversationSubTitle:
      "Hyper-growth comes with financial, operational, and compliance challenges. Our e-commerce advisors bring clarity to the complexities of scaling, funding, and platform optimisation. Let’s map your next stage of growth together. ",
  },

  // HOSPITALITY CONSULTING ADVISORY
  {
    slug: "hospitality-consulting-advisory",
    bgImage: "/images/industries/hospitality-consulting/hero.webp",
    title: "Hospitality Consulting & Advisory", // [file:4]
    subTitle:
      "Delivering comprehensive consultancy services to the hospitality sector, focusing on efficient operations, financial optimization, and exceptional guest experiences.", // [file:4]
    industryOverview: {
      icon: "/images/industries/hospitality-consulting/overview.svg",
      description:
        "The hospitality sector thrives on creating exceptional guest experiences and maintaining high operational efficiency. Key challenges include managing variable demand, optimizing revenue per available room (RevPAR), controlling labor and operational costs, and attracting investment for asset development, refurbishment, or repositioning. Strategic planning is vital for resilience in a volatile travel market.", // [file:4]
    },
    howWeHelp: [
      {
        icon: "/images/industries/e-commerce/help-1.svg",
        description:
          "Enhancing RevPAR, occupancy, and revenue optimisation strategies.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-2.svg",
        description:
          "Improving operational efficiency across asset-heavy hospitality environments.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-3.svg",
        description:
          "Strengthening financial planning for renovation, expansion, or new developments.", // [file:4]
      },
      {
        icon: "/images/industries/e-commerce/help-4.svg",
        description:
          "Elevating guest experience through service redesign and data-driven insights.", // [file:4]
      },
    ],
    keySolutions: {
      background:
        "/images/industries/hospitality-consulting/key-solutions.webp",
      description:
        "We offer expertise to ensure your hospitality venture is optimized for growth and profitability.", // [file:4]
      cardData: [
        {
          icon: "/images/industries/e-commerce/key-solutions-1.svg",
          description:
            "Financial optimisation for RevPAR, GOP margins, and asset utilisation.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-2.svg",
          description:
            "Capital planning for new developments, refurbishments, or repositioning.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-3.svg",
          description:
            "Feasibility studies and investment modelling for hospitality assets.", // [file:4]
        },
        {
          icon: "/images/industries/e-commerce/key-solutions-4.svg",
          description:
            "Advisory on operational restructuring for hotels, resorts, and mixed-use properties.", // [file:4]
        },
      ],
    },
    industryInsights:
      "Reports on travel demand, revenue management, and hospitality market movements ",
    testimonialSubTitle:
      "Experiences from hospitality leaders who strengthened operations and profitability ",
    conversationSubTitle:
      "From revenue optimisation to asset strategy and cost management, we support hospitality businesses aiming for sustainable profitability. Our advisors help you refine operations, improve service delivery, and plan long-term growth with clarity. Reach out to our experts to shape a stronger operational and financial roadmap. ",
  },

  // EDTECH CONSULTING ADVISORY
  {
    slug: "edtech-consulting-advisory",
    bgImage: "/images/industries/edtech/hero.webp",
    title: "EdTech Consulting & Advisory", // [file:4]
    subTitle:
      "Expert services to assist EdTech enterprises in strategic planning, financial management, and business transformation to lead the wave of educational innovation.", // [file:4]
    industryOverview: {
      icon: "/images/industries/edtech/overview.svg",
      description:
        "The EdTech sector is growing at an unprecedented rate as technology revolutionizes education. Companies in this space face unique challenges, including product market fit, complex regulatory compliance, scaling user acquisition, and securing the significant capital required for content development and platform growth. Navigating this emerging market smoothly requires specialized expertise.", // [file:4]
    },
    howWeHelp: [
      {
        icon: "/images/industries/edtech/help-1.svg",
        description:
          "Refining product-market fit with strategic and academic market guidance.", // [file:4]
      },
      {
        icon: "/images/industries/edtech/help-2.svg",
        description:
          "Strengthening financial models for sustainable platform growth.", // [file:4]
      },
      {
        icon: "/images/industries/edtech/help-3.svg",
        description:
          "Supporting regulatory compliance and education-sector standards.", // [file:4]
      },
      {
        icon: "/images/industries/edtech/help-4.svg",
        description:
          "Preparing EdTech ventures for fundraising, investor alignment, and scale.", // [file:4]
      },
    ],
    keySolutions: {
      background: "/images/industries/edtech/key-solutions.png",
      description:
        "We offer expertise to guide your EdTech venture through its growth lifecycle.", // [file:4]
      cardData: [
        {
          icon: "/images/industries/edtech/key-solutions-1.svg",
          description:
            "Financial modelling for content development and platform scalability.", // [file:4]
        },
        {
          icon: "/images/industries/edtech/key-solutions-2.svg",
          description:
            "Pricing and monetisation strategy for B2B/B2C learning products.", // [file:4]
        },
        {
          icon: "/images/industries/edtech/key-solutions-3.svg",
          description:
            "Advisory on regulatory compliance, accreditation, and data standards.", // [file:4]
        },
        {
          icon: "/images/industries/edtech/key-solutions-4.svg",
          description:
            "Investor-ready business plans for Series A–Series C fundraising.", // [file:4]
        },
      ],
    },
    industryInsights:
      "Updates on education technology trends, regulatory changes, and EdTech market growth ",
    testimonialSubTitle:
      "Client feedback reflecting our role in driving innovation and sustainable EdTech development ",
    conversationSubTitle:
      "EdTech companies face unique demands around scale, compliance, and capital. Our team helps refine business models, strengthen financial strategy, and support expansion with clear, data-driven planning. Talk to us about building a sustainable, high-impact growth plan that positions your platform for long-term success. ",
  },
];
